import { motion } from "framer-motion";

const CELLS = [
  { key: "today", label: "Updates today" },
  { key: "week", label: "Updates this week" },
  { key: "high_critical", label: "High / Critical", sub: "7 days", accent: true },
  { key: "security", label: "Security updates", sub: "7 days" },
  { key: "saved", label: "Saved" },
];

export default function IntelMetrics({ data, loading }) {
  return (
    <div
      data-testid="intel-metrics"
      className="grid grid-cols-2 md:grid-cols-5 border border-border bg-border gap-px"
    >
      {CELLS.map((c, i) => (
        <motion.div
          key={c.key}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
          className={`bg-background p-5 md:p-7 ${i === 4 ? "col-span-2 md:col-span-1" : ""}`}
          data-testid={`metric-${c.key}`}
        >
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
            {c.label}
            {c.sub && <span className="text-muted-foreground/60"> · {c.sub}</span>}
          </div>
          <div
            className={`mt-3 font-heading font-black text-4xl md:text-5xl tracking-tighter leading-none tabular-nums ${
              c.accent ? "text-accent" : ""
            }`}
          >
            {loading || !data ? <span className="inline-block w-12 h-9 bg-muted animate-pulse" /> : data[c.key]}
          </div>
        </motion.div>
      ))}
    </div>
  );
}
